import { createContext } from 'react'

export interface SegmentedOptionsContextValue {
  inputsName: string
}

const SegmentedOptionsContext = createContext<SegmentedOptionsContextValue>({ inputsName: '' })

export default SegmentedOptionsContext
